module.exports = __webpack_public_path__ + "static/Liam-d01e2a3083ec73b139a936f681c5ddd1.png";